export enum VehicleCategory {
    NEW = 'new',
    USED = 'used',
    PREOWNED = 'preowned',
    CERTIFIED = 'certified',
    DEMO = 'demo'
}

export enum VehicleFeatureSpecsType {
    EXTERIOR = "EXTERIOR",
    INTERIOR = "INTERIOR",
    ENTERTAINMENT = "ENTERTAINMENT",
    MECHANICAL = "MECHANICAL",
    SAFETY = "SAFETY",
    WARRANTY = "WARRANTY",
    OPTIONS = "OPTIONS"
}

export enum VehicleVendorCode {
    USED = "VW Canada - Used Vehicles - ID-Corp-2020Q2",
    NEW = "VW Canada - New Inventory - ID-Corp-2020Q2"
}